import React from 'react';
import {
  Backdrop,
  ModalWrapper,
  ModalTitle,
  Button,
  ModalActions,
} from '../Modal/modalStyle';
import Transition from '../Transition';
import styled from 'styled-components';

const Body = styled.p`
  font-size: 1.6rem;
  color: #444;
  margin: 1.2rem 0 0;
  line-height: 1.5;
  max-width: 380px;
`;

interface IdleCheckModalProps {
  onContinue: () => void;
  onSubmit: () => void;
}

export default function IdleCheckModal({ onContinue, onSubmit }: IdleCheckModalProps) {
  return (
    <Backdrop>
      <Transition className="fade" enter timeout={500}>
        <ModalWrapper>
          <ModalTitle>Still there?</ModalTitle>
          <Body>
            It&apos;s been a few minutes since your last message. Want to keep going,
            or wrap up and submit your responses?
          </Body>
          <ModalActions>
            <Button onClick={onContinue} primary>
              I&apos;m still here
            </Button>
            <Button onClick={onSubmit}>
              Submit my responses
            </Button>
          </ModalActions>
        </ModalWrapper>
      </Transition>
    </Backdrop>
  );
}
